module.exports = __webpack_public_path__ + "static/media/emotion_01.dbca09bc.png";